import React, { useContext } from "react";
import Warning from "../Warning";
import Featured from "../Featured";
import styles from "./styles";
import { StorefrontContext } from "../../../providers/storefront";
import { handleResetSearch } from "../../../helpers/searchReset";

const FeaturedList = ({ topicUid, discussions, posts }) => {
  const { setFilteredResults, setSearchInput } = useContext(StorefrontContext);

  const prepareDiscussions = (topicUid) => {
    const temp = discussions.filter((disc) =>
      disc.data.topics
        .map((topic) => topic.topic_link.uid === topicUid)
        .includes(true)
    );
    return temp.sort((a, b) =>
      a.last_publication_date.localeCompare(b.last_publication_date)
    );
  };

  return (
    <>
      <div
        className="featured-wrapper"
        onClick={() => handleResetSearch(setFilteredResults, setSearchInput)}
      >
        <div className="features-wrapper">
          {prepareDiscussions(topicUid).length ? (
            prepareDiscussions(topicUid).map((discussion, index) => (
              <Featured
                topicUid={topicUid}
                posts={posts}
                discussion={discussion}
                index={index}
                key={discussion.id}
              />
            ))
          ) : (
            <Warning />
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FeaturedList;
